import { SiUdemy, SiLinkedin } from "react-icons/si";
import { BsCloudyFill } from "react-icons/bs";

const CERTIFICATIONS_DATA = [
  {
    name: "Build Responsive Real-World Websites with HTML & CSS",
    date: "Apr. 2022",
    url: "https://ude.my/UC-7af21d63-5c2f-45f2-9a3c-701cd140a9da",
    icon: <SiUdemy size="1rem" />,
  },
  {
    name: "The Complete JavaScript Course",
    date: "Jul. 2022",
    url: "https://ude.my/UC-5c55ccfe-0953-4542-9a50-a3fcc21fa86a",
    icon: <SiUdemy size="1rem" />,
  },
  {
    name: "React: The Complete Guide",
    date: "Aug. 2022",
    url: "https://ude.my/UC-ab89ba7f-03fe-4c59-8b0a-5be3b9bc16ac",
    icon: <SiUdemy size="1rem" />,
  },
  {
    name: "Complete NodeJS Developer",
    date: "Sep. 2022",
    url: "https://ude.my/UC-49801076-5867-4307-9f32-962ef92f9385",
    icon: <SiUdemy size="1rem" />,
  },
  {
    name: "AWS Certified Solutions Architect - Associate (SAA-C02)",
    date: "Sep. 2022",
    url: "https://verify.acloud.guru/4DA1B2F30DFF",
    icon: <BsCloudyFill size="1rem" />,
  },
  {
    name: "AWS Certified Cloud Practitioner (CLF-C01)",
    date: "Sep. 2022",
    url: "https://verify.acloud.guru/7EF8CD8BCA81",
    icon: <BsCloudyFill size="1rem" />,
  },
  {
    name: "Learning GitHub",
    date: "Jul. 2022",
    url: "https://www.linkedin.com/learning/certificates/f40d8f2765e5f34a37a805467496d318febf2f6dc4a19c402c0c4eaf6c1f6fd9",
    icon: <SiLinkedin size="1rem" />,
  },
];

export default CERTIFICATIONS_DATA;
